import { notify } from 'components/Common/Toast';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { RootState } from 'redux/store';

const RequireMerchant = () => {
    const isMerchant = useSelector((state: RootState) => state?.auth?.isMerchant);
    const location = useLocation();
    if (!isMerchant) {
        notify('You have a lower role to continue!', 'warning');
        // Redirect user to home or to somewhere else when the user is not a merchant
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

export default RequireMerchant;
